import React, { useEffect, useState } from 'react'
import './UserProfile.css'
import Navbar from '../Home/Navbar/Navbar'
import profileImg from '../../assets/profile-img.jpg'
import { useAuth } from '../../auth/AuthContext'

const UserProfile = () => {
    const { profile, updateUserProfile } = useAuth()
    const [updatedName, setUpdatedName] = useState('')
    const [updatedPhone, setUpdatedPhone] = useState('')

    useEffect(() => {
        if (profile) {
            setUpdatedName(profile.name || '')
            setUpdatedPhone(profile.phone || '')
        }
    }, [profile])

    if (!profile) {
        return (
            <div>
                <Navbar/>
                <div className='user-profile-container'>
                    <p className='profile-loading'>Loading profile...</p>
                </div>
            </div>
        )
    }

    const updateProfile = async () => {
        if (updatedName === '' && updatedPhone === '') {
            alert('All fields are empty')
            return
        }

        try {
            await updateUserProfile({
                name: updatedName,
                phone: updatedPhone
            })
            alert('Profile updated!')
        } catch (err) {
            alert(err.message || 'Unable to update profile.')
        }
    }

    return (
        <div>
            <Navbar/>
            <div className='user-profile-container'>
                <div className='user-profile-left'>
                    <h2>Welcome</h2>
                    <img className='profile-img' src={profileImg} alt=""/>
                    <h2>Good Day</h2>

                    <ul>
                        <li>
                            <i className="fa fa-user" aria-hidden="true"></i>
                            <a href='#user-profile-info'>PERSONAL INFO</a>
                        </li>
                        <li>
                            <i className="fa fa-pencil mr-right-i" aria-hidden="true"></i>
                            <a href='#user-profile-updateinfo'>UPDATE INFO</a>
                        </li>
                    </ul>
                </div>

                <div className='user-profile-right'>
                    <div id='user-profile-info' className='user-profile-box'>
                        <div>
                            <h1>Profile Info</h1>
                            <div className='profile-underline'></div>
                        </div>

                        <div className='user-profile-info-div'>
                            <div>
                                <p>Name:</p>
                                <span>{profile?.name}</span>
                            </div>
                            <div>
                                <p>Email:</p>
                                <span>{profile?.email}</span>
                            </div>
                            <div>
                                <p>Phone:</p>
                                <span>{profile?.phone || 'Not provided'}</span>
                            </div>
                            <div>
                                <p>Role:</p>
                                <span>{profile?.role}</span>
                            </div>
                        </div>
                    </div>

                    <div id='user-profile-updateinfo' className='user-profile-box'>
                        <div className='profile-mr-bottom'>
                            <h1>Update Info</h1>
                            <div className='profile-underline'></div>
                        </div>

                        <p>Name:</p>
                        <input
                            type="text"
                            placeholder='name...'
                            value={updatedName}
                            onChange={(e) => setUpdatedName(e.target.value)}
                        />
                        <p>Phone:</p>
                        <input
                            type="text"
                            placeholder='phone...'
                            value={updatedPhone}
                            onChange={(e) => setUpdatedPhone(e.target.value)}
                        />
                        <br/>
                        <button onClick={updateProfile} className='profile-update-btn'>update</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserProfile
